import React from 'react';
import { Box } from '@mui/material';
import { CandidateConversionField } from './CandidateConversionField';
import { useCandidateConversionEditor } from './use-candidate-conversion-editor.hook';
import {
  useSelectedCandidateRow,
  type SelectedCandidateRow,
} from './use-selected-candidate-row.hook';

const ImportTabHeaderConversionContent: React.FC<SelectedCandidateRow> = ({
  row,
  importedElement,
}) => {
  const { isDiscarded, referenceId } = useCandidateConversionEditor({
    row,
    importedElement,
  });
  if (isDiscarded || !referenceId) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        ml: 'auto',
        mr: '8px',
      }}
    >
      <CandidateConversionField row={row} importedElement={importedElement} />
    </Box>
  );
};

/** Conversion editor in the import-tab list header. */
export const ImportTabHeaderConversion: React.FC = () => {
  const selection = useSelectedCandidateRow();
  if (!selection) return null;

  return <ImportTabHeaderConversionContent {...selection} />;
};
